import { generateAsyncReducer } from '../../../utils';
import { ELoginActions } from './enums';
import { ILoginFormResponse } from './models';

export const LoginReducer = generateAsyncReducer<ILoginFormResponse>(ELoginActions.LOGIN);
